import { mapEnumToOptions } from '@abp/ng.core';

export enum IncidentType {
  Complaint = 0,
  HealthInjury = 1,
}

export const incidentTypeOptions = mapEnumToOptions(IncidentType);
